<template>
    <div>
        <page-card :header="$t('pages.mobile_number.title')" v-if="!loading">
            <generic-notification :notifications.sync="notifications"></generic-notification>
            <b-form v-on:submit.prevent>
                <!--setting is in progress-->
                <b-form-group v-if="in_progress"
                              :label="$t('pages.mobile_number.mobile_confirmation_field')"
                              label-for="frmMobileNumberConfirmationCode">
                    <p>{{ $t('pages.mobile_number.mobile_confirmation_sentto') }} {{ mobile }}</p>
                    <p>{{ $t('pages.mobile_number.after24h') }}</p>
                    <b-form-input type="text"
                                  id="frmMobileNumberConfirmationCode"
                                  :placeholder="$t('pages.mobile_number.mobile_confirmation_field')"
                                  v-model="confirmation_code">
                    </b-form-input>
                    <b-button class="mt-4" id="btnConfirmMobile"
                              variant="primary"
                              v-on:click="confirmMobileNumber">
                        {{ $t('pages.mobile_number.confirm_code') }}
                    </b-button>
                </b-form-group>
                <!--setting is not in progress-->
                <template v-else>
                    <!--there is a number-->
                    <template v-if="isset">
                        <callout>
                            {{ $t('pages.mobile_number.mobile_field_current') }}
                            <b-input-group>
                                <b-input-group-prepend>
                                    <b-input-group-text>
                                        <b-icon-phone aria-hidden="true"/>
                                    </b-input-group-text>
                                </b-input-group-prepend>
                                <b-form-input type="tel" :value="mobile" disabled></b-form-input>
                            </b-input-group>
                            <dl class="mt-2">
                                <dt>Ländercode</dt>
                                <dd>{{ regioncode }}</dd>
                            </dl>
                        </callout>
                    </template>
                    <!--there is no number, allow user to set one-->
                    <template v-else>
                        <callout callout-class="callout-info">{{ $t('pages.mobile_number.mobile_not_set') }}</callout>
                        <b-form-group :label="$t('pages.mobile_number.mobile_field')"
                                      label-for="frmMobileNumber"
                                      :state="sendable">
                            <b-input-group>
                                <b-input-group-prepend>
                                    <b-input-group-text>
                                        <b-icon-phone aria-hidden="true"/>
                                    </b-input-group-text>
                                </b-input-group-prepend>
                                <b-form-input type="tel" id="frmMobileNumber"
                                              :placeholder="$t('pages.mobile_number.mobile_field')"
                                              v-model="mobile"
                                              :state="mobileOK">
                                </b-form-input>
                            </b-input-group>
                        </b-form-group>
                        <b-list-group>
                            {{ $t('pages.mobile_number.examples_text') }}
                            <b-list-group-item v-for="example in $t('pages.mobile_number.examples').split(',')"
                                               :key="example">
                                {{ example }}
                            </b-list-group-item>
                        </b-list-group>
                        <div
                            :class="['callout', 'mt-2', consentGiven ? 'callout-success border-success' : 'callout-danger border-danger']">
                            <b-form-group class="mt-4">
                                <b-form-checkbox
                                    id="frmConsentGiven"
                                    v-model="consentGiven"
                                    name="frmConsentGiven">
                                    {{ $t('pages.consent.text') }}
                                </b-form-checkbox>
                            </b-form-group>
                        </div>

                    </template>

                    <b-button class="mt-2"
                              variant="primary"
                              v-b-modal.modalConfirmSetMobile
                              v-if="!isset"
                              :disabled="!sendable">
                        <b-icon-upload aria-hidden="true"/>
                        {{ $t('pages.mobile_number.mobile_set') }}
                    </b-button>
                    <b-button class="mt-2"
                              variant="danger"
                              v-b-modal.modalConfirmRemoveMobile
                              v-if="isset">
                        <b-icon-trash aria-hidden="true"/>
                        {{ $t('pages.mobile_number.mobile_remove') }}
                    </b-button>
                </template>
            </b-form>
        </page-card>

        <b-modal id="modalConfirmSetMobile"
                 :title="$t('pages.mobile_number.mobile_set')"
                 title-tag="h3"
                 :ok-title="$t('common.yes')"
                 :cancel-title="$t('common.cancel')"
                 @ok="setMobileNumber"
        >
            {{ $t('pages.mobile_number.confirm') }} <p class="text-bold text-center" style="letter-spacing: .2rem;">
            {{ mobile }}</p>
            <div>
                <label for="current_password">{{ $t('common.current_password_please') }}:</label>
                <div class="input-group mb-3">
                    <input type="password" v-model="current_password" name="current_password"
                           id="current_password"/>
                </div>
            </div>
        </b-modal>

        <b-modal id="modalConfirmRemoveMobile"
                 :title="$t('pages.mobile_number.mobile_remove')"
                 title-tag="h3"
                 :ok-title="$t('common.yes')"
                 :cancel-title="$t('common.cancel')"
                 @ok="removeMobileNumber"
                 variant="danger"
        >
            {{ $t('pages.mobile_number.confirm_removal') }}
        </b-modal>
    </div>
</template>

<script>
import GenericNotification from "../layout/GenericNotification";
import Callout from "../layout/Callout";
import PageCard from "../layout/PageCard";
import LoadingInjector from "../../mixins/LoadingInjector";

export default {
    mixins: [
        LoadingInjector
    ],
    components: {
        PageCard,
        Callout,
        GenericNotification,
    },
    props: {
        rzaccount: {
            required: true,
            type: String,
        }
    },

    data() {
        return {
            notifications: [],
            data: {
                isset: false,
                in_progress: false,
            },
            mobile: '',
            regioncode: '',
            current_password: null,
            confirmation_code: '',
            consentGiven: false,
            loading: true
        }
    },
    created() {
        this.errorHandler = this.$shared.errorHandlerForResponder;
    },
    mounted() {
        console.log('Mounted MobileNumber.');

        this.$Echo.private(`rz-account.${this.rzaccount}`)
            .listen('BolognaEvent', (e) => {
                if ([
                    "AttributeChangeSuccessful",
                    "AttributeChangeFailed",
                    "AttributeRemovalSuccessful",
                    "AttributeRemovalFailed"
                ].includes(e.name)) {
                    this.notifications.push(e);
                }
            });


        this.retrieveMobileNumber();
    },
    methods: {
        retrieveMobileNumber: function () {
            this.loading = true;
            this.axios.get(this.$Bologna.secure_url(`/v1/accounting/mobile/${this.rzaccount}`))
                .then(response => {
                    this.data = response.data.data;
                    this.mobile = this.$purify.sanitize(this.data.value);
                    this.regioncode = this.$purify.sanitize(this.data.regioncode);
                    this.consentGiven = this.data.consentGiven;
                    this.current_password = null;
                })
                .catch(error => {

                })
                .finally(() => {
                    this.loading = false;
                });
        },
        removeMobileNumber: function () {
            this.axios.delete(this.$Bologna.secure_url(`/v1/accounting/mobile/${this.rzaccount}`))
                .then(response => {
                    this.data = response.data.data;
                    this.mobile = '';
                    this.regioncode = '';
                    this.current_password = null;
                })
                .catch(error => {

                });
        },
        setMobileNumber: function () {
            this.axios.post(this.$Bologna.secure_url(`/v1/accounting/mobile/${this.rzaccount}`), {
                mobile: this.mobile,
                current_password: this.current_password,
                consent: this.consentGiven,
            }).then(response => {
                this.data = response.data.data;
            })
                .catch(error => {
                    this.current_password = null;
                });
        },
        confirmMobileNumber: function () {
            this.axios.post(this.$Bologna.secure_url(`/v1/accounting/mobile-confirmation/${this.rzaccount}`), {
                confirmation_code: this.confirmation_code,
            }).then(response => {
                this.data = response.data.data;
                this.mobile = this.$purify.sanitize(this.data.value);
                this.regioncode = this.$purify.sanitize(this.data.regioncode);
                this.confirmation_code = '';
            })
                .catch(error => {

                });
        }
    },
    computed: {
        isset: function () {
            return this.data.isset && this.data.isset === true;
        },
        in_progress: function () {
            return this.data.in_progress && this.data.in_progress === true;
        },
        mobileOK: function () {
            return this.mobile.length ? this.mobile.length > 5 : false;
        },
        sendable: function () {
            return this.mobileOK && this.consentGiven === true;
        }
    }
};
</script>
